import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import {
  Row,
  Col,
  Select,
} from '@folio/stripes/components';

const DefaultLibraryEditFields = ({ libraries = [], disabled = false }) => {
  const intl = useIntl();

  const getLibraryDisplayName = (library) => {
    const translationKey = `ui-tenant-settings.loclibs.name.${library.name}`;
    return intl.formatMessage(
      { id: translationKey },
      { defaultMessage: library.name },
    );
  };

  return (
    <Row>
      <Col xs={12} md={6}>
        <Field
          name="customFields.defaultlibrary"
          component={Select}
          label={<FormattedMessage id="ui-users.defaultLibrary.library" />}
          disabled={disabled}
        >
          <option value="">
            <FormattedMessage id="ui-users.defaultLibrary.select" />
          </option>
          {libraries.map((library) => (
            <option key={library.id} value={library.id}>
              {getLibraryDisplayName(library)}
            </option>
          ))}
        </Field>
      </Col>
    </Row>
  );
};

DefaultLibraryEditFields.propTypes = {
  libraries: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
};

export default DefaultLibraryEditFields;